import * as React from 'react';
import { ArticleCoverSlider } from 'components';

interface IProps {
	coverImages: any;
}

/**
 *
 * @param props
 */
export const ArticleCover = (props: IProps) => {
	let coverSection: JSX.Element = null;
	if (props.coverImages.length === 1) {
		const coverImage = props.coverImages[0];
		coverSection = (
			<div className="bigImage">
				<img className="imageHolder" src={coverImage.href} />
			</div>
		);
	} else if (props.coverImages.length > 1) {
		coverSection = <ArticleCoverSlider coverImages={props.coverImages} />;
	}

	return <div className="articleCardCover">{coverSection}</div>;
};
